import {
  addItemToCollection,
  getItemsFromCollection,
  updateItemInCollection,
} from "directus/src/operations";

export async function createDailyWorkCapacityEntry({ item }) {
  try {
    const query = {
      fields: ["id", "date", "payroll_hours", "is_logged"],
    };
    const data = await addItemToCollection("daily_work_capacity", item, query);

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function updateDailyWorkCapacityEntry({ id, item }) {
  try {
    const query = {
      fields: ["id", "date", "payroll_hours", "is_logged"],
    };
    const data = await updateItemInCollection(
      "daily_work_capacity",
      id,
      item,
      query
    );
    return data;
  } catch (error) {
    console.error("Error updating daily work capacity entry:", error);
    throw error;
  }
}

export async function fetchDailyWorkCapacityByDate({ date, employee }) {
  try {
    const query = {
      fields: ["id", "date", "payroll_hours", "employee", "is_logged"],
      filter: {
        date: {
          _eq: date,
        },
        employee: {
          _eq: employee,
        },
      },
    };
    const data = await getItemsFromCollection("daily_work_capacity", query);

    return data?.[0];
  } catch (error) {
    console.error("Error fetching daily capacity:", error);
    throw error;
  }
}
